/**
* @title rxprescriptionhelper.js
* @description Sub-module which contains various common functionalities for pharmacy section
* @dependences
*/
define([], function() {
	var rxPrescriptionHelper = {

		init: function(options) {
			COSTCO.util.adjustDivHeights('.costco-align-height-shipping-billing-address', 50);

			// Whenever address get changed, do div heights adjustment
			$('body').bind('costco.address.added', function(event, address) {
				COSTCO.util.adjustDivHeights('.costco-align-height-shipping-billing-address', 50);
			});
		},

		drugSection: {
			drugNames: 'drugName_0 drugName_1 drugName_2 drugName_3 drugName_4 drugName_5 drugName_6 drugName_7 drugName_8 drugName_9 drugName_10 drugName_11 drugName_12 drugName_13 drugName_14',
			prescriptionNumbers: 'prescriptionNumber_0 prescriptionNumber_1 prescriptionNumber_2 prescriptionNumber_3 prescriptionNumber_4 prescriptionNumber_5 prescriptionNumber_6 prescriptionNumber_7 prescriptionNumber_8 prescriptionNumber_9 prescriptionNumber_10 prescriptionNumber_11 prescriptionNumber_12 prescriptionNumber_13 prescriptionNumber_14',
			MAX_PRESCRIPTION_NUMBER: 15,

			/**
			 * Function which dynamically creates drug section.
			 * @param {string} blockId ID of block where section will be added.
			 * @param {string} templateId ID of the template to be inserted.
			 */
			createDrugSection: function(blockId, templateId) {
				$('#' + blockId).html('');
				$.each(drugList, function(index, value) {
					rxPrescriptionHelper.drugSection.addSinglePrescriptionRow(blockId, value, templateId);
				});
				if(drugList.length % 3 > 0) {
					let emptyFieldsToAdd = 3 - drugList.length % 3;
					for(i = 0; i < emptyFieldsToAdd; i++) {
						defaultDrugElement.drugIndex = drugList.length + i;
						rxPrescriptionHelper.drugSection.addSinglePrescriptionRow(blockId, defaultDrugElement, templateId);
					}
				}
				// Init rxBoxCount value
				rxPrescriptionHelper.drugSection.setPrescriptionsCount(blockId);
			},

			/**
			 * Function which adds new prescriptions on existing section.
			 * Max number of precription sections is limited to 15
			 * @param {string} ID of block where section will be added.
			 * @param {string} templateId ID of the template to be inserted.
			 */
			addMorePrescriptions: function(blockId, templateId) {
				let rxBoxCnt = $('#' + blockId).children().length;
				let freeSpaces = rxPrescriptionHelper.drugSection.MAX_PRESCRIPTION_NUMBER - rxBoxCnt;
				let prescriptions2Add = freeSpaces < 3 ? freeSpaces : 3;

				for(i = 0; i < prescriptions2Add; i++) {
					if(i == 1) {
						$('#searchForDrug_' + defaultDrugElement.drugIndex).focus();
					}
					defaultDrugElement.drugIndex = rxBoxCnt + i;
					rxPrescriptionHelper.drugSection.addSinglePrescriptionRow(blockId, defaultDrugElement, templateId);
				}

				rxPrescriptionHelper.drugSection.setPrescriptionsCount(blockId);
			},

			/**
			 * Function which adds single prescription element on existing section.
			 * Max number of prescription sections is limited to 15
			 * @param {string} blockId ID of block where section will be added.
			 * @param {Object} jsonTemplate
			 * @param {string} templateId ID of the template to be inserted.
			 */
			addSinglePrescriptionRow: function(blockId, jsonTemplate, templateId) {
				if (jsonTemplate.hasOwnProperty("drugIndex")) { 
                    jsonTemplate.groupIndex = parseInt(jsonTemplate.drugIndex) + 1;
                }
				
				let template = COSTCO.util.tmpl(templateId, jsonTemplate);
				template = $(template);
				if (jsonTemplate.checked ==true) {
					template.find('#genericOption_' + jsonTemplate.drugIndex).prop('checked', true);
				}

				$('#' + blockId).append(template);
			},

			setPrescriptionsCount: function(blockId) {
				let rxBoxCnt = $('#' + blockId).children().length;
				$('input:hidden[name=rxBoxCount]').val(rxBoxCnt);
				if (rxBoxCnt >= 15) {
					$('#add-more-prescriptions-button').hide();
				}
			},

			setFilledPresciptionsCount: function() {
				let rxBoxCount = $('#drug-info-block').children().length;
				let count = 0;
				for (i = 0; i < rxBoxCount; i++) {
					let drugname = $('#drugName_' + i).val();
					if (typeof(drugname) !== 'undefined' && drugname.trim().length > 0) {
						count++;
					} else {
						$('#drugName_' + i).removeAttr('name');
					}
				}
				$('input:hidden[name = rxBoxCount]').val(count);
			},

			/**
			 * Drug section validation function
			 */
			drugNameValidationMethod: function(value, element, options) {
				  let numberRequired = options[0];
				  let selector = options[1];
				  let fields = $(selector, element.form);
				  let filled_fields = fields.filter(function() {
				    // it's more clear to compare with empty string
					let drugName = $(this).val();
				    return $.trim(drugName) != '';
				  });

				  if (filled_fields.length < numberRequired ) {
				    return false;
				  }
				  return true;
			},

			/**
			 * Search drug function.
			 * @param {String} index Drug index.
			 * @param {String} formId Form ID.
			 */
			searchForDrug: function(index, formId) {
				let count = $('#drug-info-block').children().length;
				let genericRequested = $('#genericOption_' + index).is(':checked');
				let searchKeyword = $('#drugName_' + index).val();

				let prescriptionForm = document.forms[formId];

				prescriptionForm.action = 'PharmacyPrescriptionDrugSearch?storeId=' + wcs.storeId
					+ '&langId=' + wcs.langId
					+ '&catalogId=' + wcs.catalogId
					+ '&isPharmacy=true';

				prescriptionForm.searchKeyword.value = searchKeyword;
				prescriptionForm.rxBox.value = index;
				prescriptionForm.genericRequested.value = genericRequested;
				prescriptionForm.rxBoxCount.value = count;

				prescriptionForm.submit();
			},
		},

		/**
		 * Marks the appropriate radio button in Shipping Option section as checked.
		 *
		 * @param {string} shippingMethod Shipping method code (expected '4', '5', or '6')
		 */
		markShippingOptionChecked: function(shippingMethod) {
			switch (shippingMethod) {
				case '4':
					$('#standard-usps').attr('checked', 'checked');
					break;
				case '5':
					$('#three-day-shipping').attr('checked', 'checked');
					break;
				case '6':
					$('#two-day-shipping').attr('checked', 'checked');
					break;
				default:
					console.error('Invalid shipping method: ' + shippingMethod);
			}
		},

		/**
		 * Opens $0 Co-Pay dialog.
		 *
		 * @param {object} $completeRequestForm Complete Prescription Request form.
		 */
		openZeroDollarDialog: function($completeRequestForm) {
			if ($completeRequestForm.is('form')) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.PRESCRIPTION_PHARMACY__ZeroDollarCopay_DialogText,
					body: $('#zero-dollar-dialog-text').html(),
					primary: messages.PRESCRIPTION_PHARMACY__CompletePrescription_ButtonText,
					primary_event: function() {
						$completeRequestForm.submit();
					},
				});
			} else {
				console.error('Illegal argument: form is expected.');
			}
		},
		/**
		 * Called when the user clicks Complete Request button.
		 * Validate Address length, according to story stry0130872
		 * @return address validation
		 */
	
		validateAddress: function() {
			let valid = true;
			let errors = [];
			$.each($('.address-1-check'), function(index, value) {
		    let address1 =$(value).text();
		    if (address1 == undefined && valid) {
	    		valid = false;
	    		errors.push(messages.ERR_ADDRESSBOOK_MISSING_SHIPPING_ADDR);
	    	}
	    	//see if address length is longer than 30 characters - stry0130872
	    	else if (address1.length > 30 && valid) {
	    		valid = false;
	    		errors.push(messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE);
	    	}
			});
    	
			$.each($('.address-2-check'), function(index, value) {
		    let address2 =$(value).text();
		    if (address2 == undefined && valid) {
	    		valid = false;
	    		errors.push(messages.ERR_ADDRESSBOOK_MISSING_SHIPPING_ADDR);
	    	}
	    	//see if address length is longer than 30 characters - stry0130872
	    	else if (address2.length > 30 && valid) {
	    		valid = false;
	    		errors.push(messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE);
	    	}
			});

    	if (!valid && errors.length > 0) {
    		COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, errors, true);	
    	}
    	
    	return valid;
		},
		/**
		 * Action to be performed when the user clicks Complete Request button.
		 *
		 * @param {Object} element HTML element.
		 * @param {boolean} hasCreditCard
		 * @param {boolean} enforceZeroDollarDialog
		 */
		completePrescriptionRequestAction: function(element, hasCreditCard, enforceZeroDollarDialog) {
			let completeRequestFormId = $(element).closest('form').attr('id');
			let $completeRequestForm = $('form[id=' + completeRequestFormId + ']');

			let isQuickFill = 'true' == $completeRequestForm.find('input[name=isQuickFill]:checked').val();

			// Order should always be placed if user selects 'Notify by email' (a.k.a. 'self checkout'),
			// i.e. when isQuickFill equals 'false'.
			if(this.validateAddress()){
				if (!isQuickFill) {
					$completeRequestForm.submit();
				} else if (enforceZeroDollarDialog) {
					this.openZeroDollarDialog($completeRequestForm);
				} else if (hasCreditCard) {
					$completeRequestForm.submit();
				} else {
					console.error('Illegal arguments.');
				}
			}
			
		},
	};

	if(typeof window.COSTCO === 'undefined') {
		window.COSTCO = new Object();
	}

	window.COSTCO.rxPrescriptionHelper = rxPrescriptionHelper;

	return rxPrescriptionHelper;
});



// WEBPACK FOOTER //
// ./js/rx/rxprescriptionhelper.js